const doc = [({"en":({"labelHotelWaitingList":({"date":"Date of stay", "email":"Email", "hotelPlanId":"Plan", "hotelRoomId":"Room type"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;